import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

import accountRoutes from './sub/account';
import errorsRoutes from './sub/errors';
import genericRoutes from './sub/generic';
import orderRoutes from './sub/orders';
import reservationsRoutes from './sub/reservations';
import messagingRoutes from './sub/messaging';
import menuRoutes from './sub/menu';
import cartRoutes from './sub/cart';
import roomsRoutes from "./sub/rooms";
import surveyRoutes from "./sub/survey";

import store from '../store';

const router = new VueRouter({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0}
    },
    routes: [
        ...surveyRoutes,
        ...roomsRoutes,
        ...genericRoutes,
        ...accountRoutes,
        ...orderRoutes,
        ...menuRoutes,
        ...cartRoutes,
        ...reservationsRoutes,
        ...messagingRoutes,
        ...errorsRoutes
    ],
});

router.beforeEach((to, from, next) => {
    //If the route requires orderOptions, check them
    if (to.matched.some(record => record.meta.requiresOrderOptions)) {
        const idMenu = store.state.order.id_menu;
        if(!idMenu || idMenu === -1){
            next({name: 'orders'});
            return;
        }
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!store.getters['auth/authenticated']) {
            next({name: 'user.login'});
        } else {
            if (to.matched.some(record => record.meta.requiresDeliveryActive)) {
                if (store.getters['restaurant/localeDeliveryActive']) {
                    next();
                } else {
                    next({name: '404'});
                }
            } else if (to.matched.some(record => record.meta.requiresStripe)) {
                if (store.state.restaurant.f_stripe) {
                    next();
                } else {
                    next({name: '404'});
                }
            } else {
                next();
            }
        }
    } else {
        next() // make sure to always call next()!
    }
});

export default router;
